export const locale = {
  lang: 'en',
  data: {
    'SHEDULE': {
      'ALERT': 'Do you want to continue with the shipment?',
      'TITLE1': 'Register release date ',
      'TITLE2': 'Register reminder',
      'TITLE3': 'Register close',
      'SELECT_DATE': 'Select a date',
      'SELECT_DATEPCIKER':'Pick a date',
      'SAVE': 'Save',
      'RECORDATORIOS': 'Reminders',
      'FECHA': 'Date ',
      'AGREGAR': 'Add',
      'EDITAR': 'Edit',
      'COMPLETAR_PASO': 'Complete step',
      'PASO_COMPLETADO': 'Step completed',
      'ERROR1': 'You can not chose a minor date than now',
      'ERROR2': 'Date must be at least 30 days reach than now',
      'ERROR3':'¿Are you sure?',
      'ERROR4':'We suggest you schedule the survey 30 days in advance due to informational emails',
      'MSJ1':'¡Warning!',
      'MSJ2':'¿Are you sure? You can not revert to this change. ',
      'MSJ3':'Yes',
      'MSJ4':'You have not programming a date',
      'MSJ5':'The survey has been launched',
      'MSJ6':'The survey has been created',
      'MSJ7':'Step is completed',
      'MSJ8':'Cancel',
      'MSJ9':'You have not created a survey',
      'MSJ10':'You have not select the survey day',
      'MSJ11':'You can not select a reminder after that the close day',
      'MSJ12':'The empleyers has finish the survet',
      'MSJ13':'Remandir save',
      'MSJ14':'You can not select a reminder before that the launch day',
      'MSJ15':'You onle have one advice left',
      'ERROR5':'Yes',
      'LANZAMIENTO': 'The survey starts on',
      'AVISO1': 'Firts advice on',
      'AVISO2': 'Second advice on',
      'AVISO3': 'Third advice on',
      'CIERRE':'The survey ends on',
      'RESULTADOS':'The result will post on',
      'SURVEY':'Loading survey',
      'MAS50':'Loading more 50 survey',
      'MENOS':'Loading less 50 survey',
      'SUCCESS_MAS50':'The \'more than 50\' survey was created successfully!',
      'SUCCESS_MENOS':'The \'less than 50\' survey was created successfully!',
      'USERS':'Loading users',
      'ENCUESTA':'Creating survey',
      'BTNSURVEY':'Create survey',
      'REMAINDER':{
        'REMAINDER1':'Reminder 30 days before the survey: ',
        'REMAINDER2':'Reminder 15 days before the survey: ',
        'REMAINDER3':'Survey Day: ',
        'REMAINDER4':'Survey Closing Date: ',
        'REMAINDER5':'Survey results: ',
        'REMAINDER51':'Reminder ',
        'REMAINDER6':'Reminder 29 days before the survey: ',
        'REMAINDER7':'Reminder 7 days before the survey: ',

      },

    }
  }
};
